import logo_sitev from '../../images/logo_sitev.webp';
import logo_about from '../../images/s_WSP1.webp';

const About = () => {

  window.addEventListener("load", () =>{
    document.querySelector(".main-image-container").classList.add('loaded');
  });

  return (
    <main className="main" id="main">
      <div className="main-container">
        <h1 className="main__title">Sistema Integrado de Inspección Técnica Vehicular</h1>
        <figure className="main-image-container">
          <img src={logo_sitev} width="400" height="267" className="main__image" alt="Logo SITEV"/>
        </figure>
        <h2 className="main__subtitle">Software para Centros de Inspección Técnica Vehicular</h2>
      </div>
      
      <div className="main-container2">
        <div className="main-container3">
          <div className="main-container-info">
            <h2 className="main__subtitle-info">¿Que es SITEV?</h2>
            <p className="main__details">
              Es un software altamente automatizado para gestionar todo el proceso de inspección técnica vehicular para lineas Livianas, Pesadas, Mixtas, Combinadas y Menores.<br/><br/>
              Está desarrollado de acuerdo a los requerimientos y normativas del Ministerio de Transportes y Comunicaciones - MTC. 
              <br/>
              <br/>
              SITEV es la mejor herramienta de gestión, administración y toma de decisiones que puede tener en su CITV. Más de 15 años presentes en el mercado y múltiples casos de éxito nos respaldan.
              <br/>
            </p>
            <figure className="main-image-details-container">
              <img className="main__image-details" height="280" width="275" src={logo_about} alt="SITEV es el software ideal para su CITV"/>
            </figure>
            <p className="main__details">
              SITEV cumple con las Resoluciones Directorales N° 3041-2009-MTC/15 y N° 4801-2017-MTC/15, que aprueban las características y especificaciones del Sistema Informático y de Comunicaciones 
              para los Centros de Inspección Técnica Vehicular.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}
 
export default About;